import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Divider, CardMedia, Grid, Button, IconButton, Icon } from '@mui/material';
import styled from '@emotion/styled';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SellRoundedIcon from '@mui/icons-material/SellRounded';
import AccessTime from '@mui/icons-material/AccessTimeRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';

import { formatGenericDate } from '../../../utils/util';

import { SectionHeaderBar, BasicFlex, LabelUpper } from '../../../utils/Common';

import { useFormikContext, FieldArray } from 'formik';

import Field from '../../../utils/FormikFields/Field';

import AutoCompleteArray from '../../../utils/FormikFields/AutoCompleteArray';

import { displayLabelProduct } from '../../../utils/displayLabels';

import Dialog from '../../../utils/utilities/Dialog';

import EditProduct from '../../Products/EditProduct';

import { NewValueContext } from '../../../contexts/NewValue';

import useIsMobile from '../../../hooks/useIsMobile';

// linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

const Container = styled.div`
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  padding: .7rem 1rem;
`

const SearchContainer = styled.div`
  margin: .5rem 0;
`

const ProductListContainer = styled(BasicFlex)`
  margin-top: 1rem;
  width: 100%;
  gap: 1rem;
`;

const StyledCard = styled(Card)`
 border-radius: 8px;
 border: 1px solid ${props => props.theme.colors.border};
 box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
 transition: all 0.2s ease-in-out;
 overflow: hidden;
 
 &:hover {
   border-color: ${props => props.theme.colors.darkBg};
   box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
 }
`;

const ProductCard = styled(BasicFlex)`
  height: 100%;
  align-items: stretch;
`;

const ImageContainer = styled(BasicFlex)`
  background-image: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  border-radius: 5px;
  border-right: 1px solid ${props => props.theme.colors.border};
  /* min-height: 8rem; */
  width: 8rem;
  justify-content: center;
  align-items: center;
`;

const ServiceImage = styled('img')`
 width: 100%;
 height: 100%;
 object-fit: cover;
`;

const ServiceItemDetails = styled(BasicFlex)`
  min-width: fit-content;
`;

const ServiceTitle = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;
  /* color: ${props => props.theme.colors.mildText}; */
  /* margin-bottom: .5rem; */
`

const DetailLineStyles = styled(BasicFlex)`
  /* font-size: 1.4rem; */
  color: ${props => props.theme.colors.mildText};
`;

const PriceDisplay = styled.div`
  height: min-content;

  .MuiInputBase-input {
    padding: .2rem !important;
  }
`

const ServiceActions = styled(BasicFlex)`
  @media (${props => props.theme.breaks.down('md')}) {
      margin-top: 1rem;
    }
`;

const QuantityActions = styled(BasicFlex)`
  border-radius: 12px;
  background-color: ${props => props.theme.colors.darkBg};
  width: fit-content;

   .MuiInputBase-input {
    padding: .2rem !important;
    
  }

  .MuiTextField-root {
    border: none !important;
    outline: none !important;
  }
`;



const DetailLine = ({ Icon, value}) => {
  return (
    <DetailLineStyles justify="flex-start" gap="1rem">
      {Icon ? <Icon fontSize='small' color="icon" /> : null}
      {value}
    </DetailLineStyles>
  )
}

const Quantity = ({ index, remove }) => {
  const { values, setFieldValue } = useFormikContext() || {};
  let quantity = +values?.products[index]?.quantity || 1;
  const increase = () => {
    setFieldValue(`products.${index}.quantity`, quantity + 1)
  }
  const decrease = () => {
    if (quantity - 1 === 0) return remove(index);
    setFieldValue(`products.${index}.quantity`, quantity - 1)
  }
  return (
   <QuantityActions>
      <IconButton size="small" color="basic" onClick={decrease}><Remove /></IconButton>
      <Field name={`products.${index}.quantity`} InputProps={{ sx: {margin: 0, width: "3rem", paddingLeft: "0 !important", fontSize: "1.4rem", fontWeight: "500", gap: ".5rem"} }} sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: 'none',
          },
        },
        '& .MuiInputBase-input': {
          textAlign: 'center',
          color: 'secondary.main'
        },
      }} />
      <IconButton size="small" color="basic" onClick={increase}><Add /></IconButton>
    </QuantityActions>
  )
}


const ProductLine = ({ product = {}, index, remove }) => {
  let { image, name, description } = product;

  const { isMobile } = useIsMobile();
  return (
    <StyledCard sx={{p: "0 !important", width: "100%"}} variant='outlined'>
      <ProductCard justify="flex-start">
        <ImageContainer align="stretch">
        {image ? (
           <ServiceImage src={image} alt={name} />
         ) : (
           <ShoppingCartCheckoutRoundedIcon sx={{ fontSize: 32, color: '#bdbdbd' }} />
         )}
        </ImageContainer>
        <CardContent sx={{p: ".5rem 1.6rem !important", width: "100%"}}>
         <BasicFlex justify="space-between" dir={isMobile ? "column" : "row"}>
          <ServiceItemDetails dir="column" gap=".5rem" align="flex-start">
            <ServiceTitle>{name}</ServiceTitle>
            <DetailLine value={description} />
          </ServiceItemDetails>

          <ServiceActions align={isMobile ? "flex-start" : "flex-end"} justify="space-between" gap="1rem" dir={isMobile ? "column" : "row"}>
            <PriceDisplay>
             <Field name={`products.${index}.rate`} type="number" InputProps={{sx: {margin: 0, width: "9rem", paddingLeft: ".5rem !important", fontSize: "1.6rem", fontWeight: "500", gap: ".5rem"}, startAdornment: <AttachMoneyRoundedIcon fontSize='small' />}} />
            </PriceDisplay>
            <Quantity index={index} remove={remove} />
            <BasicFlex width="8rem">
              <Button size="small" color="basic" startIcon={<DeleteForeverRoundedIcon />} onClick={() => remove(index)}>
                Remove
              </Button> 
              
            </BasicFlex>

          </ServiceActions>
         </BasicFlex>
        </CardContent>
      </ProductCard>
      
    </StyledCard>
  )
}

const Products = () => {
  const { values, setFieldValue } = useFormikContext() || {};

  const [ newValue, addNewValue ] = useState();

  useEffect(() => {
      if (newValue) {
        let id = newValue?.product_id?.toString();
        let index = values?.products?.findIndex(product => product?.product_id?.toString() === id);
        let item = {
          product_id: newValue?.product_id,
          rate: newValue?.price,
          name: newValue?.name,
          description: newValue?.description,
          item_type: "product",
          quantity: 1
        }
        if (index === -1) {
          setFieldValue("products", [...values?.products, item]);
        }
      }
    }, [newValue]);

  let updates = [
    {name: "product_id", field: "product_id"},
    {name: "rate", field: "price"},
    {name: "name", field: "name"},
    {name: "description", field: "description"}
  ];
  return (
    <NewValueContext.Provider value={{ newValue, addNewValue }}>
      <Grid size={{xs: 12}}>
        <Container>
          <BasicFlex>
            <LabelUpper>Products</LabelUpper>
            <Dialog
              title="Add New Product"
              toggle={<Button color="info" variant="text" sx={{py: "0", fontSize: "1.2rem"}}>Add New Product</Button>}
              size="xl"
              useForm={true}
            >
              <EditProduct dialog={true} ignore_id={true} />
            </Dialog>
          </BasicFlex>
        
          
            <FieldArray name="products">
              {({ push, remove }) => (
                <>
                <SearchContainer>
                    <AutoCompleteArray fieldName="name" name="add_products" label="Select Services" url="products" placeholder='Add Products' push={push} additionalFields={{quantity: 1, item_type: "product"}} formUpdates={updates} disabled={!values?.customer_id} displayLabel={displayLabelProduct} />
                </SearchContainer>
                  {values.products.length ? <ProductListContainer dir="column">
                  { values.products.map((product, index) => (
                      <ProductLine key={index} product={product} index={index} remove={remove} />
                    ))}
                  </ProductListContainer> : null}
                </>
              )}
            </FieldArray>
            {/* <ServiceLine image="" title="Wash & Set" /> */}
            
          
        </Container>
      </Grid>
    </NewValueContext.Provider>
  )
};

export default Products;